import React, { useRef } from 'react'
import { Link } from "react-router-dom";
import { Pane, Text, TextInput, Button, EyeOpenIcon, EyeOffIcon, Dialog, toaster } from 'evergreen-ui'
import { useAPI } from '../Api';
import { useLibrary } from '../Library';
import {
    useParams,
    useNavigate,
    useLocation,
} from "react-router-dom";

import { ContactUs } from '../Misc';
import { AuthFrame } from './index.js'

export function LogInArea() {
    let navigate = useNavigate();
    const [eye, setEye] = React.useState(true);
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [isShown, setIsShown] = React.useState(false)
    const API = useAPI();
    const PWInput = useRef(null);
    const hidePassword = (e) => {
        eye ? PWInput.current.type = "text" : PWInput.current.type = "password";
    }

    const [invalidPostcode, setInvalidPostcode] = React.useState(false)
    const [noDelivery, setNoDelivery] = React.useState(false)


    let checkloging = (e) => {
        console.log('-------------------------------------------------')
        e.preventDefault();
        return API.login(username, password).catch((e) => {
            // console.log('>catch>>', e);
            if (!e) return e;

            if (e.statusCode && e.statusCode == 401) {
                if (e.error && e.error.description ==
                    "Invalid postcode") {
                    setInvalidPostcode(true)
                }

                if (e.error && e.error.description ==
                    "No Delivery") {
                    setNoDelivery(true)

                }
                if (e.error && e.error.description ==
                    "Waiting for approval") {
                    toaster.notify("Pending access, please wait until one of our sale reps contact you via email")

                }
                if (e.error && (e.error.description == "Failed to Find" || e.error.description == "Login Failed")) {
                    toaster.danger("Username OR Password is Incorrect")
                }

            }

            return true
        }).then((r) => { if (r) navigate("/projects") })
    }



    return (API.isAuth() != false ? <Link to="/projects">Library</Link> :
        <Pane width="50%" margin="auto">
            <Dialog
                isShown={invalidPostcode}
                title="Delivery address"
                onCloseComplete={() => {
                    setInvalidPostcode(false);
                    var win = window.open('https://duraproducts.com.au/account/', '_blank');
                    win.focus();
                }}
                confirmLabel="Update Address now"
                hasCancel={false}
            >
                <Text>Sorry, there seems to be an issue with your current delvery address.<br />
                    <br /> Your postcode needs to be a valid australian postcode.<br /><br />
                    When you have updated it, please try loggin in again.</Text>
                <br /><br />
                <Text>
                    <i>If you are unable to for any reason,
                        <ContactUs> please let us know</ContactUs></i>
                </Text>
            </Dialog>

            <Dialog
                isShown={noDelivery}
                title="Delivery address"
                onCloseComplete={() => {
                    setNoDelivery(false);

                }}

                onConfirm={() => {
                    setNoDelivery(false);
                    var win = window.open('https://duraproducts.com.au/account/', '_blank');
                    win.focus();

                }}
                confirmLabel="Update Address now"
                cancelLabel="Close"

            >
                <Text>Sorry, DuraProducts does not deliver to your address right now.<br />
                    We will reach out to you when there are any updates in the furture.<br /><br />

                    If you need to update your address, press the button below.<br /><br />
                </Text>
                <Text>
                    <i>If have any questions
                        <ContactUs> please let us know</ContactUs></i>
                </Text>
            </Dialog>


            <form onSubmit={(e) => checkloging(e)}>

                <TextInput autoComplete="username"  width={"100%"} placeholder="Email" value={username} onChange={(e) => { setUsername(e.target.value) }} />
                <Pane display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"center"} marginTop={8}>
                    <TextInput autoComplete="current-password" 
                       type="password" width={"100%"} placeholder="Password" value={password} ref={PWInput} onChange={(e) => { setPassword(e.target.value) }} />

                </Pane>

                <Button type="submit" appearance='primary' marginTop={8} width={"100%"}>
                    LOG IN
                </Button>




            </form></Pane>
    )

}
export function LogIn() {
    const API = useAPI();
    let theLibrary = useLibrary();

    let navigate = useNavigate();

    React.useEffect(() => {
        theLibrary.clear();

        setTimeout(() => {
            if (API.isAuth() != false) {
                navigate("/projects")
            }
        }, 1000)

    }, [])





    return (API.isAuth() != false ? <Link to="/projects">Library</Link> :
        <AuthFrame >
            <LogInArea></LogInArea>

            <Pane display={"flex"} flexDirection={"column"} alignItems={"left"} justifyContent={"center"} marginTop={8} width="50%" margin="auto">
                <Text>Don't have an accout? <Link style={{ color: 'blue' }} to="/signup">Request Access</Link></Text>
                <Text>Forgot password? <a href="https://duraproducts.com.au/password-reset/">Reset Password</a></Text>
            </Pane>
            <div style={{
                position: 'fixed',
                top: 0,
                color: 'lightgray',
                left: 0,
                background: 'transparent'
            }}>{process.env.RELEASE}</div >

        </AuthFrame >)


}
